const id = (value) => String(value?._id || value?.id || value || '');
const commercialRoles = new Set(['admin', 'superAdmin', 'sales', 'seller']);
const requesters = new Set(['lisbeth.velasquez@coffeevending.com.pa', 'valentina@coffeevending.com.pa']);

// Mirror the existing commercial close permission; the authenticated API remains authoritative.
export const canCloseDemonstration = (item, user = {}) => {
    if (!item || item.status !== 'pending_commercial_close' || user.isActive === false || user.isDeleted) return false;
    const role = user.role?.uid || '';
    if (!commercialRoles.has(role) && !requesters.has(String(user.email || '').trim().toLowerCase())) return false;
    return role !== 'seller' || Boolean(id(user) && id(item.createdBy) === id(user));
};

// Link by stored movement IDs only. A normal exchange or matching customer is not a demonstration.
export const findMovementDemonstration = (movement, rows = []) => {
    if (!movement?._id) return null;
    for (const row of rows) {
        const demo = row?.rawDemo || row;
        if ([demo?.installationMovement, demo?.removalMovement].some(value => value && id(value) === id(movement))) return demo;
    }
    return null;
};
